module.exports = __webpack_public_path__ + "static/feather-4-c4c5e8c09476fdc9a50aa33aa7eec6df.png";